<template>
    <div class="bg-gray-50 dark:bg-gray-700">
        <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
            <div class="max-w-3xl mx-auto divide-y-2 divide-gray-200">
                <h2 class="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl dark:text-white">
                    Frequently asked questions
                </h2>
                <dl class="mt-6 space-y-6 divide-y divide-gray-200 dark:divide-white">
                    <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
                        <dt class="text-lg">
                            <DisclosureButton class="text-left w-full flex justify-between items-start text-gray-400 dark:text-white">
                                <span class="font-medium text-gray-900 dark:text-white">
                                    {{ faq.question }}
                                </span>
                                <span class="ml-6 h-7 flex items-center">
                                    <ChevronDownIcon :class="[open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform']" aria-hidden="true" />
                                </span>
                            </DisclosureButton>
                        </dt>
                        <DisclosurePanel as="dd" class="mt-2 pr-12">
                            <p class="text-base text-gray-500 dark:text-white">
                                {{ faq.answer }}
                            </p>
                        </DisclosurePanel>
                    </Disclosure>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/outline'

const faqs = [
	{
        question: 'How much is it?',
        answer: 'We offer both free and paid experiences, you will always have the chance to participate. Additional booster/token packages are also available from our store!',
    },
	{
        question: 'How do the points work?',
        answer: 'The points are awarded based on the official starting price of the horse and its finishing position. For instance, a winner at 10/1 would give you 50 points (5x) for a full list of how many places and multipliers please see the specific points page.',
    },
	// {
    //     question: 'How much can I win?',
    //     answer: 'The maximum amount you can win is unlimited as the more people that join in, the higher the pots will go. Minimum daily prize pot guaranteed at £50.',
    // },
	{
        question: 'How will I know if I win?',
        answer: 'You can follow your progress in the leaderboards and any appropriate mini leagues you are involved with (the points totals will be the same across all the formats) Winners will be notified by email with instructions regarding pay-outs.',
    },
	{
        question: 'What happens if I have a non-runner?',
        answer: 'You can change your selection at any stage up to 2 mins before the official off time of the race. If the race starts and your horse is still a non-runner you will not be awarded any points.',
    },
	// {
    //     question: 'Why Racing Stars over conventional betting?',
    //     answer: 'Racing stars is a better choice over conventional betting because you always have a chance of winning (Fantasy league style with points).',
    // },
	{
        question: 'Is this real live horse racing?',
        answer: 'Yes!',
    },
]

export default {
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon,
    },
    setup() {
        return {
            faqs,
        }
    },
}

</script>
